/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CustomTaskCreatePriority } from './customTaskCreatePriority';
import type { CustomTaskCreateTaskNoteDoc } from './customTaskCreateTaskNoteDoc';

/**
 * Free-form note. Spec §8.4 marks ``task_note_doc`` REQUIRED.
 */
export interface CustomTaskCreate {
  job_id: string;
  candidate_id: string;
  assignee_user_id: string;
  due_at?: string | null;
  priority?: CustomTaskCreatePriority;
  title?: string | null;
  type: 'custom_task';
  task_note_doc: CustomTaskCreateTaskNoteDoc;
}
